import { Layout, theme } from 'antd'
import { useTranslation } from 'react-i18next'
import styles from '../less/BaseLayout.module.less'
import notFound from '../resources/img/page-not-found.svg'
import useDocumentTitle from '../lib/useDocumentTitle'
import { useLogo } from '../lib/themeController'

export function NotFound() {
  const { token } = theme.useToken()
  const { t } = useTranslation()
  const logo = useLogo('bw')

  useDocumentTitle(t('frontend:common.pageNotFoundTitle'))

  return (
    <Layout
      className={styles.baseLayout}
      style={{ backgroundSize: '200px 200px' }}
    >
      <Layout.Content style={{ textAlign: 'center', margin: token.marginLG }}>
        <img
          src={logo}
          alt="cleverlohn"
          style={{ display: 'block', margin: '0 auto', width: 150 }}
        />
        <img
          src={notFound}
          alt="404 - Page not found"
          style={{
            width: '95vw',
            maxWidth: '800px',
            marginTop: token.marginXL,
          }}
        />
      </Layout.Content>
    </Layout>
  )
}
